
import React from "react";

const ClientConsent: React.FC = () => {
  return (
    <div className="tw-w-full tw-pt-6 lg:tw-pt-12 tw-pb-32 sm:tw-pb-0 tw-overflow-y-scroll scroll-hidden">
      <div className="profile-section tw-w-full max-w-6xl">
        <div className="tw-flex tw-items-center sm:tw-space-x-4">
          <div>
            <h3 className="tw-text-[20px] tw-font-semibold tw-mb-2 tw-m-0">Einwilligung des Klienten</h3>
            <p className="tw-text-sm sm:tw-text-[14px] tw-text-gray-500 tw-mb-0">
Hierbei handelt es sich um ein Dokument zum Herunterladen, das Sie an Ihre Klient:innen weiterleiten können, um deren Zustimmung zur Nutzung von LumaNote für die Transkription von Sitzungsaudioaufnahmen einzuholen. Sollte ein:e Klient:in der Aufzeichnung nicht zustimmen, können Sie LumaNote  mithilfe der „Diktat“-Funktion dennoch verwenden.           </p>
          </div>
                  
                  <div className="tw-bg-white  tw-w-full  md:tw-w-auto  tw-fixed tw-bottom-0 tw-left-0 tw-px-3 tw-py-4 tw-flex tw-items-center tw-justify-end md:tw-p-0  md:tw-bg-transparent  md:tw-static tw-z-10 ">

            <a href="/Datenschutz_Einwilligungserklaerung.pdf" download className="_button_19rto_40 _purple_19rto_126 _filled_19rto_80 disabled:!tw-opacity-60 tw-cursor-pointer tw-px-4 tw-w-full sm:tw-w-fit">
            <button
                            className="_button_19rto_40 _purple_19rto_126 _filled_19rto_80 tw-px-9 tw-w-full md:tw-w-auto">
              <div className="_btnFlex_19rto_32">
                <p className="tw-m-0 tw-block tw-font-normal tw-truncate tw-text-[16px]">Dokument herunterladen</p>
              </div>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientConsent;
